import { MapPin, Globe } from "lucide-react";

const serviceAreas = [
  "Los Angeles County",
  "San Bernardino County",
  "Riverside County",
  "Orange County",
  "San Diego County",
  "Ventura County",
];

export default function ServiceAreas() {
  return (
    <section className="py-24 md:py-32 bg-black" data-testid="service-areas-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="h-px w-12 bg-[#D4AF37]" />
                <span className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm">Service Areas</span>
              </div>
              <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-white">
                All Across <span className="text-[#D4AF37]">Southern California</span>
              </h2>
            </div>

            <p className="text-zinc-400 leading-relaxed">
              From the beaches of Orange County to the mountains of San Bernardino — 
              I cover 6 counties and know every market inside out.
            </p>

            <div className="grid grid-cols-2 gap-4">
              {serviceAreas.map((area) => (
                <div key={area} className="flex items-center gap-3" data-testid={`service-area-${area}`}>
                  <MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                  <span className="text-zinc-300 text-sm">{area}</span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 pt-4">
              <Globe className="w-5 h-5 text-[#D4AF37]" />
              <span className="text-zinc-300">
                I speak <span className="text-white font-semibold">English, Spanish, Arabic & Portuguese</span>
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div className="card-dark p-8 text-center space-y-2">
              <p className="text-4xl font-black text-[#D4AF37]">6</p>
              <p className="text-zinc-400 text-sm uppercase tracking-wider">Counties Served</p>
            </div>
            <div className="card-dark p-8 text-center space-y-2">
              <p className="text-4xl font-black text-[#D4AF37]">11</p>
              <p className="text-zinc-400 text-sm uppercase tracking-wider">Sales This Year</p>
            </div>
            <div className="card-dark p-8 text-center space-y-2">
              <p className="text-3xl font-black text-[#D4AF37]">$138K–$1.5M</p>
              <p className="text-zinc-400 text-sm uppercase tracking-wider">Price Range</p>
            </div>
            <div className="card-dark p-8 text-center space-y-2">
              <p className="text-4xl font-black text-[#D4AF37]">4</p>
              <p className="text-zinc-400 text-sm uppercase tracking-wider">Languages</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
